import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

type Props = {
  open: boolean;
  title: string;
  description?: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
  variant?: "default" | "destructive";
  onConfirm: () => void;
  onClose: () => void;
};

export default function ConfirmModal({
  open,
  title,
  description,
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  loading,
  variant = "default",
  onConfirm,
  onClose,
}: Props) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/40" onClick={loading ? undefined : onClose} />
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-md rounded-xl bg-white shadow-lg border border-slate-200">
          <div className="flex items-start justify-between gap-3 p-4 border-b border-slate-200">
            <div>
              <h3 className="text-base font-semibold text-slate-900">{title}</h3>
              {description && <p className="text-sm text-slate-600 mt-1">{description}</p>}
            </div>

            <button
              onClick={loading ? undefined : onClose}
              className="p-1 rounded hover:bg-slate-100"
              aria-label="Fechar"
            >
              <X size={18} />
            </button>
          </div>

          <div className="p-4 flex items-center justify-end gap-2">
            <Button variant="outline" onClick={onClose} disabled={loading}>
              {cancelText}
            </Button>
            <Button variant={variant} onClick={onConfirm} disabled={loading}>
              {loading ? "Processando..." : confirmText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
